import { $$ } from "@utils/select";
import Flickity from "flickity";

const FIX = "flickity-flex";

export default (sliderOptions = {}) => {
  let slider = null;

  const options = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: "left",
    contain: true,
    ...sliderOptions,
  };

  return {
    $$slides: null,
    currentIndex: 0,
    totalSlides: null,

    init() {
      this.$$slides = $$('[x-ref="slide"]', this.$el);
      this.$refs.slider.classList.add(FIX);
      this.totalSlides = this.$$slides.length;

      slider = new Flickity(this.$refs.slider, options);
      slider.on("select", (index) => {
        this.currentIndex = index;
      });

      setTimeout(() => slider.resize(), 100);
    },

    next() {
      slider.next();
    },

    prev() {
      slider.previous();
    },
  };
};
